var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkspace64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round",
    d: "M32 4.5l24.5 13.75v27.5L32 59.5 7.5 45.75v-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    fillOpacity: 0.15,
    fill: "currentColor",
    strokeLinejoin: "round",
    d: "M32 13.5l16.5 9.25v18.5L32 50.5l-16.5-9.25v-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M32 4v10m0 36v10M7 18l9 5m41-5l-9 5M7 46l9-5.5m32 0l9 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.15,
    fill: "currentColor",
    d: "M16 40.5L7 46l25 14 25-14V18l-9 5v17.5L32 50z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace64);
export default __webpack_public_path__ + "static/media/workspace-64.5fafc39a.svg";
export { ForwardRef as ReactComponent };